import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export interface ISwitchControlProps {
  /**
   * An optional id for the switch, otherwise generated
   */
  id?: string;
  /**
   * The state of the switch
   */
  checked: boolean;
  /**
   * Is the switch disabled
   */
  disabled?: boolean;
  /**
   * An optional label to display with the switch
   */
  label?: string;
  /**
   * The onChange handler
   */
  onChange?: (newState: boolean) => void;
}

/**
 * Component for displaying a simple switch
 * @param {ISwitchControlProps} props
 */
export const SwitchControl = (props: ISwitchControlProps) => {
  const [checked, setChecked] = useState(props.checked);
  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  // Generate an id if not given
  const switchId = props.id || uuidv4();

  const handleSwitchChange = (checked: boolean) => {
    if (props.disabled) {
      return;
    }

    setChecked(checked);
    
    if (props.onChange) {
      props.onChange(checked);
    }
  };

  return (
    <>
      <div className="switch switch-lg switch--bordered">
        <input
          type="checkbox"
          defaultChecked={checked}
          value="true"
          id={switchId}
          className="switch"
          onChange={(event) => handleSwitchChange(event.target.checked)}
          disabled={props.disabled}
        />
        <label htmlFor={switchId} className="custom-control-label">{props.label}</label>
      </div>
    </>
  );
};
